import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MessageSquare, TriangleAlert } from "lucide-react";

const SHOW_MS = 14000; // how long the tip stays on screen each cycle

// Fetch the on-screen chat tip settings (public; admin-editable).
export function useChatTip() {
  const [cfg, setCfg] = useState(null);
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const load = () => api.get("/spotlight/chat-tip").then((r) => setCfg(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 120000);
    const tick = setInterval(() => setNow(Date.now()), 1000);
    return () => { clearInterval(t); clearInterval(tick); };
  }, []);
  if (!cfg || !cfg.enabled || !(cfg.tips || []).length) return null;
  const period = Math.max(2, cfg.interval_min || 5) * 60000;
  // Clock-aligned: appears SHOW_MS each period, cycling through the tips in order.
  if ((now % period) >= SHOW_MS) return null;
  const tips = cfg.tips;
  return { text: tips[Math.floor(now / period) % tips.length], color: cfg.color || "#ffd60a", level: cfg.level || "calm" };
}

export function ChatTipBug({ tip }) {
  if (!tip || !tip.text) return null;
  const color = tip.color || "#ffd60a";
  const severe = tip.level === "active" || tip.level === "dangerous";
  return (
    <div
      data-testid="broadcast-chat-tip"
      className="chat-tip-bug pointer-events-none absolute bottom-[66px] left-1/2 z-30 flex -translate-x-1/2 items-center gap-3 overflow-hidden rounded-[6px] bg-[#0a0f1c] px-5 py-3 shadow-[0_8px_26px_rgba(0,0,0,0.55)]"
      style={{ boxShadow: `0 8px 26px rgba(0,0,0,0.55)`, outline: `2px solid ${color}`, outlineOffset: "-2px" }}
    >
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[5px] text-[#0a0f1c]" style={{ background: color }}>
        {severe ? <TriangleAlert className="h-5 w-5" strokeWidth={2.8} /> : <MessageSquare className="h-5 w-5" strokeWidth={2.6} />}
      </span>
      <span className="font-oswald text-[26px] font-black uppercase tracking-wide text-white" data-testid="broadcast-chat-tip-text">{tip.text}</span>
    </div>
  );
}
